// ADARSH - FINAL LAYOUT WITH ALL TASKS
document.addEventListener('DOMContentLoaded', () => {
if (window.location.href.includes('products/smartfit-plan')) {

  const EXCEPTION_CLASSES = ['product__block--buy_buttons', 'cart-drawer-button'];

  function hasExceptionElement(element) {
    if (!element) return false;
    return EXCEPTION_CLASSES.some(cls => element.closest(`.${cls}`));
  }

  const modalId = 'an-burnfit-leave-modal';
  let pendingNavigation = null;
  let modalShown = false;

  /* -------------------------------
      ⭐ POPUP COOLDOWN (10 DAYS)
  --------------------------------*/
  const POPUP_COOLDOWN_KEY = "burnfit_popup_next_allowed";

  function isPopupAllowed() {
    const nextAllowed = localStorage.getItem(POPUP_COOLDOWN_KEY);
    if (!nextAllowed) return true;
    return Date.now() > parseInt(nextAllowed);
  }

  function setPopupCooldown(days = 1) {
    const nextTime = Date.now() + days * 24 * 60 * 60 * 1000;
    localStorage.setItem(POPUP_COOLDOWN_KEY, nextTime.toString());
  }

  /* --------------------------------
         CREATE POPUP
  ---------------------------------*/
  function createModal() {
    if (document.getElementById(modalId + '-overlay')) return;

    const overlay = document.createElement('div');
    overlay.id = modalId + '-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = 0;
    overlay.style.left = 0;
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.background = 'rgba(0,0,0,0.5)';
    overlay.style.zIndex = 999999;
    overlay.style.display = 'none';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';

    const modal = document.createElement('div');
    modal.setAttribute('class', 'an--burnfit-popup');
    modal.id = modalId;
    modal.style.zIndex = 1000000;
    modal.style.maxWidth = '480px';
    modal.style.width = '90%';

    const price = burnfit_data_price.replace('₹', '').replace(',', '').replace('.00', '');
    const compare_price = burnfit_data_comprice.replace('₹', '').replace(',', '').replace('.00', '');
    const calculation = Math.trunc(((parseInt(compare_price) - parseInt(price)) / parseInt(compare_price)) * 100);

    modal.innerHTML = `
        <div class="sub-wrapper-burnfit-popup" style="font-family: DM Sans; color: #036;">

            <div class="close-btn" style="cursor:pointer;">
                <i class="fa-solid fa-xmark"></i>
            </div>

            <div class="an--product-burnfit">
                <div class="content-box">
                    <h4 style="position: relative; padding-top: 15px;">
                        Not ready for the full program?
                        <img src="https://cdn.shopify.com/s/files/1/0770/9900/8243/files/SUMISURA_MIDNNIGHT_BLUE_1.png?v=1761725406" width="15px" style="position:absolute;top:0;left:0;">
                    </h4>
                    <p style="font-size: 12px;margin: 0;">You can still begin your journey with the BurnFit Plan.</p>
                </div>

                <div class="image_box">
                    <img src="https://cdn.shopify.com/s/files/1/0770/9900/8243/files/Banner-3-NewBurn.png?v=1763535338" width="30%" style="margin:auto" alt="product-image-burnfit"/>
                </div>

                <div class="burnfit-add-to-cart" style="text-align: center;">
                    <div style="position: relative;">
                      <span style="position:absolute;left:15%;top:-80%;background:#D63A2F;border-radius:5px;padding:2px 5px;font-size:12px;color:white;font-family:DM Sans;font-weight:600;">Save ${calculation}%</span>
                      <span style="font-size:18px;font-weight:600;">Selling Price ${burnfit_data_price}</span> 
                      <s style="opacity: 0.5;font-size:14px;font-weight:400;">MRP${burnfit_data_comprice}</s><br>
                    </div>

                    <div style="font-size: 12px;"> ${burnfit_data_description} </div>

                    <button class="button button-secondary" id="custom-add-to-cart" data-variant-id="${burnfit_first_available_variant}" style="margin: 20px 0;font-size: 14px;background: #036;color: white;">Try BurnFit first</button>

                    <div id="custom-cart-response" style="color:#036;"></div>
                </div>
            </div>

        </div>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    /* --------------------------------
          ADD TO CART FUNCTIONALITY
    ---------------------------------*/
    const button = document.getElementById('custom-add-to-cart');
    const responseBox = document.getElementById('custom-cart-response');

    button.addEventListener('click', function (event) {
      event.stopPropagation();

      const variantId = this.dataset.variantId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      })
      .then(response => response.json())
      .then(() => {
        responseBox.innerHTML = `<p style="color: green; font-size:14px; margin-top:10px;">Item added to cart!</p>`;

        setTimeout(() => {
          hideModal();
          // ✅ Direct navigation instead of beforeunload
          if (pendingNavigation && pendingNavigation.type === 'link') {
            const url = pendingNavigation.href;
            pendingNavigation = null;
            window.location.assign(url);
          } else {
            window.location.reload();
          }
        }, 2000);
      });
    });

    modal.querySelector('.close-btn').addEventListener('click', (ev) => {
      ev.stopPropagation();
      setPopupCooldown(1);
      hideModal();
      if (pendingNavigation && pendingNavigation.type === 'link') {
        const url = pendingNavigation.href;
        pendingNavigation = null;
        window.location.assign(url);
      }
    });

    modal.addEventListener('click', (ev) => ev.stopPropagation());
  }

  /* --------------------------------
        SHOW / HIDE POPUP
  ---------------------------------*/
  function showModal() {
    if (!isPopupAllowed()) return;

    createModal();
    const overlay = document.getElementById(modalId + '-overlay');
    if (!overlay || modalShown) return;

    overlay.style.display = 'flex';
    modalShown = true;
  }

  function hideModal() {
    const overlay = document.getElementById(modalId + '-overlay');
    if (overlay) overlay.remove();
    pendingNavigation = null;
    modalShown = false;
  }

  /* --------------------------------
        INTERCEPT LINK CLICKS
  ---------------------------------*/
  document.addEventListener('click', (e) => {

    if (!isPopupAllowed()) return;
    if (hasExceptionElement(e.target)) return;

    const overlay = document.getElementById(modalId + '-overlay');

    if (
      overlay &&
      overlay.style.display === 'flex' &&
      overlay.contains(e.target) &&
      !document.getElementById(modalId).contains(e.target)
    ) {
        setPopupCooldown(1);
        hideModal();
        return;
    }

    const a = e.target.closest('a');
    if (!a) return;

    e.preventDefault();
    pendingNavigation = { type: 'link', href: a.href };
    showModal();

  }, true);

  /* --------------------------------
        INTERCEPT FORM SUBMIT
  ---------------------------------*/
  document.addEventListener('submit', (e) => {
    if (!isPopupAllowed()) return;
    if (hasExceptionElement(e.target)) return;

    e.preventDefault();
    pendingNavigation = { type: 'form', form: e.target };
    showModal();
  }, true);

  /* --------------------------------
            ESC CLOSE
  ---------------------------------*/
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modalShown) {
      setPopupCooldown(1);
      hideModal();
    }
  });

  /* --------------------------------
         HANDLE NAVIGATION
  ---------------------------------*/
  function proceedNavigation() {
    if (!pendingNavigation) return;

    if (pendingNavigation.type === 'link') {
      const url = pendingNavigation.href;
      pendingNavigation = null;
      window.location.assign(url);
      return;
    }

    if (pendingNavigation.type === 'form') {
      const form = pendingNavigation.form;
      pendingNavigation = null;
      form.dataset.skipLeaveProtect = '1';
      form.submit();
      return;
    }
  }

  window.addEventListener('pageshow', () => {
    pendingNavigation = null;
    modalShown = false;
    const o = document.getElementById(modalId + '-overlay');
    if (o) o.remove();
  });

}
});











// ADARSH - INTERMEDIATE LAYOUT WITH WORKING ENVIRONMENT
// document.addEventListener('DOMContentLoaded', () => {
// if(window.location.href.includes('products/smartfit-plan')){
//   const EXCEPTION_CLASSES = ['product__block--buy_buttons', 'cart-drawer-button'];
// function hasExceptionClass(element) {
//   return EXCEPTION_CLASSES.some(cls => element.classList.contains(cls));
// }

//   const modalId = 'an-burnfit-leave-modal';
//   let pendingNavigation = null;
//   let modalShown = false;

//   // Create modal container (your HTML will be injected inside)
//   function createModal() {
//     if (document.getElementById(modalId + '-overlay')) return;

//     const overlay = document.createElement('div');
//     overlay.id = modalId + '-overlay';
//     overlay.style.position = 'fixed';
//     overlay.style.top = 0;
//     overlay.style.left = 0;
//     overlay.style.width = '100%';
//     overlay.style.height = '100%';
//     overlay.style.background = 'rgba(0,0,0,0.5)';
//     overlay.style.zIndex = 999999;
//     overlay.style.display = 'none';
//     overlay.style.alignItems = 'center';
//     overlay.style.justifyContent = 'center';

//     const modal = document.createElement('div');
//     modal.setAttribute('class', 'an--burnfit-popup');
//     modal.id = modalId;
//     modal.style.zIndex = 1000000;
//     modal.style.maxWidth = '480px';
//     modal.style.width = '90%';

//     // ⬇️ YOUR EXACT HTML (unchanged)
//     const price = burnfit_data_price.replace('₹', '').replace(',','').replace('.00','');
//     const compare_price = burnfit_data_comprice.replace('₹', '').replace(',','').replace('.00','');
//     const calculation = Math.trunc(((parseInt(compare_price) - parseInt(price)) / parseInt(compare_price)) * 100);
//     modal.innerHTML = `
//         <div class="sub-wrapper-burnfit-popup" style="font-family: DM Sans; color: #036;">

//             <div class="close-btn" style="cursor:pointer;">
//                 <i class="fa-solid fa-xmark"></i>
//             </div>
//             <div class="an--product-burnfit">
//                 <div class="content-box">
//                     <h4 style="position: relative;padding-top: 15px;">
//                         Not ready for the full program?
//                         <img src="https://cdn.shopify.com/s/files/1/0770/9900/8243/files/SUMISURA_MIDNNIGHT_BLUE_1.png?v=1761725406" width="15px" style="position: absolute;top: 0;left: 0;">
//                     </h4>
//                     <p style="font-size: 12px;margin: 0;">You can still begin your journey with the BurnFit Plan.</p>
//                 </div>
//                 <div class="image_box">
//                     <img src="https://cdn.shopify.com/s/files/1/0770/9900/8243/files/Banner-3-NewBurn.png?v=1763535338" width="30%" style="margin:auto" alt="product-image-burnfit"/>
//                 </div>
//                 <div class="burnfit-add-to-cart" style="text-align: center;">
//                     <div style="position: relative;">
//                       <span style="position: absolute;left: 15%;top: -80%;background: #D63A2F;border-radius: 5px;padding: 2px 5px;font-size: 12px;color: white;font-family: "DM Sans";font-weight: 600;">Save ${calculation}%</span>
//                       <span style="font-size: 18px;font-weight: 600;">Selling Price ${burnfit_data_price}</span> <s style="opacity: 0.5;font-size: 14px;font-weight: 400;">MRP${burnfit_data_comprice}</s><br>
//                     </div>
//                     <div style="font-size: 12px;"> ${burnfit_data_description} </div>
//                     <!-- <p style="font-size: 14px;margin: 0;">Start with our 60-day Burn Phase to help control cravings, support metabolism, and reset your system.<br> A focused approach to experience SmartFit before fully committing.</p> -->
//                     <button class="button button-secondary" id="custom-add-to-cart" data-variant-id="${burnfit_first_available_variant}" style="margin: 20px 0;font-size: 14px;background: #036;color: white;">Try BurnFit first</button>
//                     <div id="custom-cart-response" style="color: #036;"></div>
//                 </div>
//             </div>

//         </div>
//     `;

//     overlay.appendChild(modal);
//     document.body.appendChild(overlay);

// const button = document.getElementById('custom-add-to-cart');
//   const responseBox = document.getElementById('custom-cart-response');

//   button.addEventListener('click', function (event) {
//   event.stopPropagation(); // avoid triggering leave-protection

//   const variantId = this.dataset.variantId;

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({
//       items: [{ id: variantId, quantity: 1 }]
//     })
//   })
//   .then(response => {
//     if (!response.ok) throw new Error('Error adding to cart');
//     return response.json();
//   })
//   .then(data => {

//     console.log('Added to cart:', data);

//     // ✅ Show success message
//     responseBox.innerHTML = `
//       <p style="color: green; font-size:14px; margin-top:10px;">
//         Item added to cart!
//       </p>
//     `;

//     // ❗ Stop the browser from asking "Do you want to reload?"
//     window.removeEventListener('beforeunload', beforeUnloadHandler);

//     // Wait 3 seconds so user sees the message
//     setTimeout(() => {

//       // Close modal cleanly
//       const overlay = document.getElementById('an-burnfit-leave-modal-overlay');
//       if (modal) modal.style.display = 'none';
//       if (overlay) overlay.style.display = 'none';

//       // Reload page
//       window.location.reload();

//     }, 3000);
//   })
//   .catch(error => {
//     console.error(error);
//     responseBox.innerHTML = `<p style="color: red;">Failed to add item.</p>`;
//   });
// });


//     // close button → behave as proceed
//     const closeBtn = modal.querySelector('.close-btn');
//     if (closeBtn) {
//       closeBtn.addEventListener('click', (ev) => {
//         ev.stopPropagation();
//         proceedNavigation();
//       });
//     }

//     // also prevent clicks inside modal from bubbling to the document click handler
//     modal.addEventListener('click', (ev) => {
//       ev.stopPropagation();
//     });
//   }

//   function showModal() {
//     createModal();
//     const overlay = document.getElementById(modalId + '-overlay');
//     if (!overlay) return;
//     if (modalShown) return; // already shown
//     overlay.style.display = 'flex';
//     modalShown = true;
//   }

//   function hideModal() {
//     const o = document.getElementById(modalId + '-overlay');
//     if (o) o.style.display = 'none';
//     pendingNavigation = null;
//     modalShown = false;
//   }

//   // Native browser confirm on refresh/close/back
//   function beforeUnloadHandler(e) {
//     // Prevent unload — modern browsers will show their native dialog
//     e.preventDefault();
//     e.returnValue = '';
//     return '';
//   }
//   window.addEventListener('beforeunload', beforeUnloadHandler);

//   // Helper: determine whether a link click should be intercepted
//   function shouldInterceptLinkClick(a, ev) {
//     if (!a || !a.href) return false;
//     // Allow ctrl/cmd/shift/alt or non-left clicks (user intent to open in new tab/window)
//     if (ev.button !== 0) return false; // only left click
//     if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return false;
//     // Respect target _blank and explicit skip attribute
//     if (a.target && a.target.toLowerCase() === '_blank') return false;
//     if (a.dataset && a.dataset.skipLeaveProtect !== undefined) return false;
//     // If link is same-page hash jump, ignore
//     try {
//       const url = new URL(a.href, location.href);
//       if (url.origin === location.origin && url.pathname === location.pathname) {
//         // If only hash differs, allow
//         if (url.hash && (location.href.split('#')[0] + url.hash) === url.href) {
//           return false;
//         }
//       }
//     } catch (err) {
//       // ignore URL parse errors and continue interception
//     }
//     // Do not intercept clicks that originate from inside the modal
//     const overlay = document.getElementById(modalId + '-overlay');
//     if (overlay && overlay.contains(ev.target)) return false;
//     return true;
//   }

//   // intercept link clicks
//   // intercept link clicks
// document.addEventListener('click', (e) => {

//     // If click matches any exception class, skip popup logic
//     if (hasExceptionClass(e.target) || hasExceptionClass(e.target.closest('*'))) {
//       return; // allow normal click behavior
//     }

//     const overlay = document.getElementById(modalId + '-overlay');

//     // If modal is open and click happens on overlay outside modal, treat it as "stay"
//     if (
//       overlay && 
//       overlay.style.display === 'flex' &&
//       overlay.contains(e.target) &&
//       !document.getElementById(modalId).contains(e.target)
//     ) {
//       e.stopPropagation();
//       e.preventDefault();
//       return;
//     }

//     const a = e.target.closest('a');
//     if (!a) return;

//     if (!shouldInterceptLinkClick(a, e)) return;

//     e.preventDefault();
//     pendingNavigation = { type: 'link', href: a.href };
//     showModal();

// }, true);


//   // intercept form submit
//   document.addEventListener('submit', (e) => {
//     // if submit originated from inside the modal, let it proceed
//     const overlay = document.getElementById(modalId + '-overlay');
//     if (overlay && overlay.contains(e.target)) return;

//     const form = e.target;
//     if (form.dataset && form.dataset.skipLeaveProtect !== undefined) return;

//     e.preventDefault();
//     pendingNavigation = { type: 'form', form: form };
//     showModal();
//   }, true);

//   // If user clicks the Add To Cart button (or any .button-secondary) inside modal -> proceed
//   document.addEventListener('click', (e) => {
//     const btn = e.target.closest('.button-secondary');
//     if (!btn) return;
//     // ensure the button is inside the modal overlay
//     const overlay = document.getElementById(modalId + '-overlay');
//     if (overlay && overlay.contains(btn)) {
//       e.stopPropagation();
//       proceedNavigation();
//     }
//   });

//   // allow escape to close (stay)
//   document.addEventListener('keydown', (e) => {
//     if (e.key === 'Escape') {
//       // If modal visible, hide (stay)
//       if (modalShown) hideModal();
//     }
//   });

//   // Navigation logic
//   function proceedNavigation() {
//     // Remove beforeunload temporarily to allow programmatic navigation
//     window.removeEventListener('beforeunload', beforeUnloadHandler);

//     if (!pendingNavigation) {
//       // nothing pending — just hide modal
//       hideModal();
//       return;
//     }

//     if (pendingNavigation.type === 'link') {
//       const url = pendingNavigation.href;
//       pendingNavigation = null;
//       hideModal();
//       // Use assign to keep history
//       window.location.assign(url);
//       return;
//     }

//     if (pendingNavigation.type === 'form') {
//       const form = pendingNavigation.form;
//       pendingNavigation = null;
//       hideModal();
//       // mark to skip interceptor (defensive) then submit
//       form.dataset.skipLeaveProtect = '1';
//       form.submit();
//       return;
//     }

//     // fallback
//     pendingNavigation = null;
//     hideModal();
//   }

//   // If page becomes visible again (back/forward), clear pending state
//   window.addEventListener('pageshow', () => {
//     pendingNavigation = null;
//     modalShown = false;
//     const o = document.getElementById(modalId + '-overlay');
//     if (o) o.style.display = 'none';
//   });
// }
// });


// ADARSH - BASIC POPUP STYLE

/* document.addEventListener('DOMContentLoaded', ()=>{
    if(window.location.href.includes('products/smartfit-plan') == true){
        document.addEventListener('beforeunload', ()=>{
            const div = document.createElement('div');
            div.setAttribute('class', 'an--burnfit-popup');
            div.innerHTML = `<div class="sub-wrapper-burnfit-popup" style="font-family: "DM Sans";color: #036;">
                                <div class="close-btn">
                                    <i class="fa-solid fa-xmark"></i>
                                </div>
                                <div class="an--product-burnfit">
                                    <div class="content-box">
                                        <h4 style="position: relative;padding-top: 15px;">
                                            Not ready for the full program?
                                            <img src="https://cdn.shopify.com/s/files/1/0770/9900/8243/files/SUMISURA_MIDNNIGHT_BLUE_1.png?v=1761725406" width="15px" style="position: absolute;top: 0;left: 0;">
                                        </h4>
                                        <p style="font-size: 12px;margin: 0;">You can still begin your journey with the BurnFit Plan.</p>
                                    </div>
                                    <div class="image_box">
                                        <img src="https://cdn.shopify.com/s/files/1/0770/9900/8243/files/Products.png?v=1763106980" width="40%" style="margin:auto" alt="product-image-burnfit"/>
                                    </div>
                                    <div class="burnfit-add-to-cart" style="text-align: center;">
                                         <p style="font-size: 14px;margin: 0;">Start with our 60-day Burn Phase to help control cravings, support metabolism, and reset your system.<br> A focused approach to experience SmartFit before fully committing.</p>
                                        <button class="button button-secondary" style="margin: 20px 0;font-size: 14px;background: #036;color: white;">Add To Cart</button>
                                    </div>
                                </div>
                             </div>`
            document.body.insertAdjacentElement('beforebegin', div);
                document.body.style.filter = "brightness(0.5) blur(3px)";
                document.body.style.pointerEvents = "none";
            document.body.style.background = "grey";
            document.querySelector('.close-btn i').addEventListener('click', ()=>{
                div.remove();
            document.body.style.filter = "unset";
                document.body.style.pointerEvents = "unset";
            document.body.style.background = "unset";
            })
        })
    }
}) */